import { GroupInterface, LocationInterface, LocationVarKey, LocationWithVariablesInterface, UserAddress } from "@swivl-mono/types";

import { APIService } from "../Service/API.Service";

// LINK apps/server/src/API/Locations/Locations.Controller.ts
export class LocationsAPI {
  static async getGroupsAndLocations(orgId: number) {
    return APIService.Server.get<GroupInterface[]>(`/locations/org/${orgId}/groups-and-locations`);
  }
  static async getGroupsAndLocationsInternal(orgId: number) {
    return APIService.Server.get<GroupInterface[]>(`/locations/org/${orgId}/groups-and-locations-internal`);
  }
  static async createLocation(orgId: number, name: string, groupId: number) {
    return APIService.Server.post<LocationInterface>(`/locations/org/${orgId}/location`, { name, groupId });
  }
  static async setGroupForLocation(orgId: number, locationId: number, groupId: number) {
    return APIService.Server.put<LocationInterface>(`/locations/org/${orgId}/location/${locationId}/group/${groupId}`);
  }
  static async createGroup(orgId: number, name: string) {
    return APIService.Server.post<GroupInterface>(`/locations/org/${orgId}/group`, { name });
  }
  static async deleteLocation(orgId: number, locationId: number) {
    return APIService.Server.delete(`/locations/org/${orgId}/location/${locationId}`);
  }
  static async deleteGroup(orgId: number, groupId: number) {
    return APIService.Server.delete(`/locations/org/${orgId}/group/${groupId}`);
  }

  static async getLocationsNearPostalCode(orgId: number, postalCode: string, distance: number) {
    return APIService.Server.get<
      LocationWithVariablesInterface<
        | LocationVarKey.CountryCode
        | LocationVarKey.PostalCode
        | LocationVarKey.BrandId
        | LocationVarKey.AvatarURL
        | LocationVarKey.Address
        | LocationVarKey.City
        | LocationVarKey.State
      >[]
    >(`/locations/org/${orgId}/near-postal-code`, { postalCode, distance });
  }
  static async getLocationByURL(orgId: number, url: string) {
    return APIService.Server.get<LocationWithVariablesInterface<any>[]>(`/locations/org/${orgId}/by-url`, { url: url });
  }

  static async getLocationsWithVariables<T extends LocationVarKey>(
    orgId: number,
    locationVarKeys: T[],
  ): Promise<LocationWithVariablesInterface<T>[]> {
    return APIService.Server.get<LocationWithVariablesInterface<T>[]>(`/locations/org/${orgId}/locations-with-variables`, {
      locationVarKeys: locationVarKeys.join(","),
    });
  }

  static async getLocationVariablesForAllLocations(orgId: number, keys: LocationVarKey[]): Promise<LocationWithVariablesInterface<any>[]> {
    return APIService.Server.get<LocationWithVariablesInterface<LocationVarKey>[]>(`/locations/org/${orgId}/location-variables-for-all-locations`, {
      keys: keys.join(","),
    });
  }
}
